export default __webpack_public_path__ + "static/ppneuemachina-inktrapregular-58b56b47a87d9f30bd35ff1551f0355c.woff";